import classNames from "classnames";
import {Picture} from "@/shared/ui/Picture";
import styles from "./ProductMarkers.module.scss";

type Props = {
    sticker?: string | null;
    className?: string;
};

export const ProductMarkers = ({sticker, className}: Props) => {
    if (!sticker) return null;

    return (
        <div className={classNames(styles.marker, className)}>
            <Picture src={sticker} alt={`sticker`} classes={{image: styles.sticker}} />
        </div>
    );
};
